import getNamespacedName from './getNamespacedName';

const getNamespacedObject = (namespace, object) => {
  if (object == null || typeof object !== 'object') {
    return null;
  }

  const result = {};
  Object.entries(object).forEach(([key, value]) => {
    result[key] = getNamespacedName(namespace, value);
  });

  return result;
};

export default getNamespacedObject;



// WEBPACK FOOTER //
// ./src/store/utils/getNamespacedObject.js